module.exports = __webpack_public_path__ + "img/tert-butyl-peroxybenzoate-details-sigma-1024x420-min.51c6ad33.png";